export default {
  namespaced: true,

  state: {
    despachos: [],
  },

  getters: {
    despachos(state) {
      return state.despachos;
    },
  },

  mutations: {
    SET_DESPACHOS(state, value) {
      state.despachos = value;
    },
    SET_DESPACHO_ESTADO(state, value) {
      if (value.index >= 0 && value.index < state.despachos.length)
        state.despachos[value.index] = value.estado;
    },
  },

  actions: {
    setDispatches({ commit }, data) {
      commit("SET_DESPACHOS", data);
    },
    setDispatchState({ commit }, index, estado) {
      commit("SET_DESPACHOS", { index: index, estado: estado });
    },
  },
};
